import {
    Box,
    Heading,
    Grid,
    GridItem,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    Center,
    Select,
    Divider,
    Textarea,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalFooter,
    ModalHeader,
    Text
} from "@chakra-ui/react";
import usePaymentForm, {
    NAME,
    ID_NUMBER,
    MOBILE,
    TEL,
    PAYMENT_CNT,
    MEMO,
    amount_per_member
} from './form.hook'
import { Controller } from 'react-hook-form'
import _ from 'lodash'
import scrollBarCssConfig from '../style/scrollBarCssConfig'
import { useCallback, useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form"
import { ArrowForwardIcon, RepeatIcon } from "@chakra-ui/icons"
import CurrencyFormat from 'react-currency-format';
import axios from "axios";
import { urls, MerID } from '../config'

export default function Form() {

    const {
        handleSubmit,
        register,
        errors,
        isSubmitting,
        onSubmit,
        onPostData,
        control,
        watch,
        isOpen,
        onOpen,
        onClose,
        totalAmount,
        urlEnc
    } = usePaymentForm()

    const { fields, replace } = useFieldArray({
        control,
        name: "members",
    });

    let WATCH_ALL = watch()
    let WATCH_PAYMENT_CNT = watch(PAYMENT_CNT)  

    useEffect(() => {
        let members = []

        for (let i = 1; i <= WATCH_PAYMENT_CNT; i++) {
            members.push({ name: "", checkDate: "" })
        }

        replace(members)

    }, [WATCH_PAYMENT_CNT, replace])

    return <Box
        p={10}
        overflow="auto"
        h="100%"
        w="100%"
        css={scrollBarCssConfig}
    >
        <Heading
            as='h1'
            size={{ base: 'xl', md: '2xl' }}
            lineHeight={2}
        >
            和信醫院<br />健康檢查網路繳費
        </Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
                templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
                gap={5}
                py={10}
            >
                <GridItem>
                    <FormControl isInvalid={errors[NAME]}>
                        <FormLabel
                            htmlFor={NAME}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            繳款人姓名
                        </FormLabel>
                        <Input
                            id={NAME}
                            {...register(NAME)}
                            variant='outline'
                            borderColor={"gray.900"}
                            size={{ base: 'md', md: 'lg' }}
                        />
                        <FormErrorMessage>
                            {errors[NAME] && errors[NAME].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
                <GridItem>
                    <FormControl isInvalid={errors[ID_NUMBER]}>
                        <FormLabel
                            htmlFor={ID_NUMBER}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            身份證字號
                        </FormLabel>
                        <Input
                            id={ID_NUMBER}
                            {...register(ID_NUMBER)}
                            variant='outline'
                            borderColor={"gray.900"}
                            size={{ base: 'md', md: 'lg' }}
                        />
                        <FormErrorMessage>
                            {errors[ID_NUMBER] && errors[ID_NUMBER].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
                <GridItem>
                    <FormControl isInvalid={errors[MOBILE]}>
                        <FormLabel
                            htmlFor={MOBILE}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            繳款人手機
                        </FormLabel>
                        <Input
                            id={MOBILE}
                            {...register(MOBILE)}
                            variant='outline'
                            borderColor={"gray.900"}
                            size={{ base: 'md', md: 'lg' }}
                        />
                        <FormErrorMessage>
                            {errors[MOBILE] && errors[MOBILE].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
                <GridItem>
                    <FormControl isInvalid={errors[TEL]}>
                        <FormLabel
                            htmlFor={TEL}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            室內電話
                        </FormLabel>
                        <Input
                            id={TEL}
                            {...register(TEL)}
                            borderColor={"gray.900"}
                            variant='outline'
                            size={{ base: 'md', md: 'lg' }}
                        />
                        <FormErrorMessage>
                            {errors[TEL] && errors[TEL].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
                <GridItem
                    colSpan={{ base: 1, md: 2 }}
                >
                    <FormControl
                        id={PAYMENT_CNT}
                        isInvalid={errors[PAYMENT_CNT]}
                    >
                        <FormLabel
                            htmlFor={TEL}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            繳款人數
                        </FormLabel>
                        <Controller
                            name={PAYMENT_CNT}
                            render={
                                ({ field }) => <Select
                                    {...field}
                                    placeholder="請選擇繳款人數"
                                    size={{ base: 'md', md: 'lg' }}
                                    variant='outline'
                                    borderColor={"gray.900"}
                                >
                                    {_.map([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], (item, key) => {
                                        return <option value={item} key={item}>{item}</option>
                                    })}
                                </Select>
                            }
                            control={control}
                        />
                        <FormErrorMessage>
                            {errors[PAYMENT_CNT] && errors[PAYMENT_CNT].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
                {WATCH_PAYMENT_CNT && <GridItem colSpan={{ base: 1, md: 2 }}>
                    <Grid
                        templateColumns={{ base: "repeat(1, 1fr)", md: "200px repeat(1, 1fr)" }}
                        border="3px solid"
                        borderColor="gray.300"
                        borderRadius={5}
                        p={5}
                        gap={5}
                    >
                        {fields.map((field, index) => (
                            <Member key={field.id} isLast={parseInt(WATCH_PAYMENT_CNT) === index + 1} {...{ control, index, field, errors, register }} />
                        ))}
                    </Grid>
                </GridItem>}
                <GridItem colSpan={{ base: 1, md: 2 }}>
                    <FormControl isInvalid={errors[MEMO]}>
                        <FormLabel
                            htmlFor={MEMO}
                            fontSize={{ base: 'lg', md: 'xl' }}
                        >
                            備　　註（如有特別交代事項，您可以200字以內文字在此說明。）
                        </FormLabel>
                        <Textarea
                            id={MEMO}
                            {...register(MEMO)}
                            variant='outline'
                            borderColor={"gray.900"}
                            h={"200px"}
                            resize="none"
                        />
                        <FormErrorMessage>
                            {errors[MEMO] && errors[MEMO].message}
                        </FormErrorMessage>
                    </FormControl>
                </GridItem>
            </Grid>

            <Center>
                <Button
                    isLoading={isSubmitting}
                    borderRadius={5}
                    type="submit"
                    variant="solid"
                    colorScheme='purple'
                    size={{ base: 'md', md: 'lg' }}
                    rightIcon={<ArrowForwardIcon />}
                >
                    下一步
                </Button>
            </Center>
        </form>
        <form id="CTBCForm" name="CTBCForm" method="post" action={urls.sslAuth}>
            <input type="hidden" name="merID" value={MerID} />
            <input type="hidden" name="URLEnc" value={urlEnc} />
        </form>
        <Confirm {...{ isOpen, onClose, onOpen, WATCH_ALL, totalAmount, onPostData }} />
    </Box>

}

function Member({ isLast, control, index, field, errors, register }) {

    var date = new Date();
    date.setDate(date.getDate() + 1);

    return <>
        <GridItem>
            <FormControl isInvalid={errors?.members?.[index]?.name}>
                <FormLabel
                    htmlFor={field.id + "-name"}
                    fontSize={{ base: 'lg', md: 'xl' }}
                >
                    姓名（{index + 1}）
                </FormLabel>
                <Input
                    id={field.id + "-name"}
                    {...register(`members.${index}.name`)}
                    variant='outline'
                    borderColor={"gray.900"}
                    size={{ base: 'md', md: 'lg' }}
                />
                <FormErrorMessage>
                    {errors?.members?.[index]?.name?.message}
                </FormErrorMessage>
            </FormControl>
        </GridItem>
        <GridItem>
            <FormControl isInvalid={errors?.members?.[index]?.checkDate}>
                <FormLabel
                    htmlFor={field.id + "-checkDate"}
                    fontSize={{ base: 'lg', md: 'xl' }}
                >
                    檢查日期
                </FormLabel>
                <Input
                    id={field.id + "-checkDate"}
                    {...register(`members.${index}.checkDate`)}
                    variant='outline'
                    type="date"
                    borderColor={"gray.900"}
                    size={{ base: 'md', md: 'lg' }}
                    min={date.toISOString().split("T")[0]}
                    onKeyDown={(e) => e.preventDefault()}
                    // onkeydown="return false"
                />
                <FormErrorMessage>
                    {errors?.members?.[index]?.checkDate?.message}
                </FormErrorMessage>
            </FormControl>
        </GridItem>
        <GridItem display={isLast ? { base: "none", md: "none" } : { base: "block", md: "none" }}>
            <Divider border={"3px"} borderColor="gray.300" boxSizing="border-box" />
        </GridItem>

    </>
}


function Confirm({ isOpen, onClose, WATCH_ALL, totalAmount, onPostData }) {

    const [captcha, setCaptcha] = useState(null)

    const [capImg, setCapImg] = useState(null)

    const [captchaInput, setCaptchaInput] = useState("")

    const loadCaptcha = useCallback(async () => {


        if (isOpen) {
            const imgData = await axios.get('https://staff.kfsyscc.org/ca/captcha.jpg', { responseType: 'blob', withCredentials: true })

            let objcetURL = URL.createObjectURL(imgData.data)
            setCapImg(objcetURL)

            const capData = await axios.get('https://staff.kfsyscc.org/ca/digits', { withCredentials: true })
            setCaptcha(capData.data.digit)

        }

    }, [isOpen])


    useEffect(() => {
        loadCaptcha()
    }, [loadCaptcha])


    return <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent overflow={"hidden"}>
            <ModalCloseButton />
            <ModalBody p={0}>
                <Box bgColor="teal.300" py={5} px={5} >
                    <Text
                        fontSize={{ base: "xl", md: "2xl" }}
                    >
                        刷卡金額
                    </Text>
                    <Text
                        fontSize={{ base: "3xl", md: "4xl" }}
                        color="white"
                    >
                        <CurrencyFormat
                            value={totalAmount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </Text>
                </Box>
                <Box py={5} px={5} lineHeight={2}>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        繳款人姓名：{WATCH_ALL.NAME}
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        身份證字號：{WATCH_ALL.ID_NUMBER}
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        繳款人手機：{WATCH_ALL.MOBILE}
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        室內電話：{WATCH_ALL.TEL}
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        繳款人數：{WATCH_ALL.PAYMENT_CNT}
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        受檢人名單（姓名/受檢日期）
                    </Text>
                    {_.map(WATCH_ALL.members, (item, key) => {
                        return <Text pl={5} fontSize={{ base: "md", md: "lg" }} key={key}>
                            {key + 1}. {item.name}/{item.checkDate}
                        </Text>
                    })}
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        總　　計：繳費 NT
                        <CurrencyFormat
                            value={amount_per_member}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />&nbsp;
                        X&nbsp;{WATCH_ALL.PAYMENT_CNT}&nbsp;=&nbsp;
                        NT<CurrencyFormat
                            value={totalAmount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />元 整
                    </Text>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        備　　註：{WATCH_ALL.MEMO}
                    </Text>
                    <Box
                        display={"flex"}
                        alignItems="flex-end"
                    >
                        <img src={capImg} alt="captcha" width={"150px"} />
                        <Button
                            colorScheme='teal'
                            variant={"outline"}
                            leftIcon={<RepeatIcon />}
                            onClick={()=>{loadCaptcha()}}
                        >
                            重新整理
                        </Button>
                    </Box>
                    <Text
                        fontSize={{ base: "md", md: "lg" }}
                    >
                        請輸入驗證碼
                    </Text>
                    <Input
                        value={captchaInput}
                        onChange={(e)=>{setCaptchaInput(e.target.value)}}
                        size={{ base: 'md', md: 'lg' }}
                        variant='outline'
                        width={"200px"}
                        borderColor={"gray.900"}
                    />
                </Box>

            </ModalBody>

            <ModalFooter>
                <Button colorScheme='blue' variant={"outline"} mr={3} onClick={onClose}>
                    取消
                </Button>
                <Button
                    colorScheme='blue'
                    onClick={()=>{                       
                        if(captcha !== captchaInput){
                            alert("驗證碼錯誤")
                            return
                        }else{                            
                            onPostData()
                        }                        
                    }}
                >確認</Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
}